import { colors } from "config"
import { hash } from "helpers/utils"

const colorHash = s => colors[Math.abs(hash(s) % colors.length)]
export default colorHash
